(() => {
  const getTarget = (name) => {
    if (name === 'proof') return document.querySelector('[data-forest-goddess-proof]');
    if (name === 'reviews') return document.querySelector('[id*="loving_product_reviews_carousel"]');
    if (name === 'fit') return document.querySelector('[id*="loving_size_recommender"]');
    if (name === 'product') return document.querySelector('[id^="ProductInformation-"]');
    return null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fgd-scroll-to]');
    if (!trigger) return;
    const target = getTarget(trigger.dataset.fgdScrollTo);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
